import { useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { ActKc3LevelEnum } from 'gql/graphql';

import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { uerChangeActKC3LevelGql } from '../components/ActKC3ListTable/actKC3ListQueries';

const requestId = 'uerChangeActKC3Level';

interface IUseUerChangeActKC3Level {
    contractId: number;
    refreshProject: () => void;
}

export const useUerChangeActKC3Level = (props: IUseUerChangeActKC3Level) => {
    const { contractId, refreshProject } = props;
    const dispatch = useDispatch();
    const [uerChangeActKC3LevelReset] = useResetStoreData({ requestId });

    const [, , , uerChangeActKC3LevelRequest] = useRequest({
        requestId,
        query: uerChangeActKC3LevelGql,
        withEffect: false,
        dependenciesUpdater: refreshProject,
    });

    return useCallback(
        (actKC3Level: ActKc3LevelEnum) => {
            uerChangeActKC3LevelReset(undefined);
            dispatch(uerChangeActKC3LevelRequest({ contractId, actKC3Level }));
        },
        [contractId, dispatch, uerChangeActKC3LevelRequest, uerChangeActKC3LevelReset],
    );
};
